import React from "react";
import DataCtx from "./DataCtx";
import FetchApiCtx from "./FetchApiCtx";
import IDataResponse from "./IDataResponse";
import Loading from "../Loading";

const DataProvider: React.FC<React.PropsWithChildren<{}>> = ({children}) => {

    const api = React.useContext(FetchApiCtx);

    const [ loading, setLoading ] = React.useState(false);
    const [ data, setData ] = React.useState<IDataResponse | undefined>(undefined);
    const [ err, setErr ] = React.useState<string | undefined>(undefined);


    const loadData = async () => {
        try {
            const newData = await api.getData();
            setData(newData);
        } catch (err) {
            setErr(err.toString());
        } finally {
            setTimeout(loadData, 60000);
        }
    };

    React.useEffect(() => {
        setLoading(true);
        loadData();
    }, []);

    return (
        <>
            { !loading && <>Initializing...</> }
            { loading && !data && !err && <Loading /> }
            { !data && err && <>Error: {err}</> }
            { data && <DataCtx.Provider value={data}>{children}</DataCtx.Provider> }
        </>
    );
}

export default DataProvider;